export const GLOW_TYPES = [
  'Button',
  'ChatVoice',
  'IconButton',
  'ToolOutput',
] as const
export type GlowType = (typeof GLOW_TYPES)[number]

export type GlowConfig = {
  amplitude: number
  secondaryAmplitude: number
  primaryFreq: number
  secondaryFreq: number
  speed: number
  blur: number
  opacityPink: number
  opacityPurple: number
  opacityBlue: number
  margin: number
}

const ChatVoice: GlowConfig = Object.freeze({
  amplitude: 8,
  secondaryAmplitude: 0.75,
  primaryFreq: 75,
  secondaryFreq: 25,
  speed: 5,
  blur: 0,
  opacityPink: 0.1,
  opacityPurple: 0.1,
  opacityBlue: 0.2,
  margin: 0,
})

const Button: GlowConfig = Object.freeze({
  amplitude: 6,
  secondaryAmplitude: 0.33,
  primaryFreq: 25,
  secondaryFreq: 10,
  speed: 4,
  blur: 0,
  opacityPink: 0.1,
  opacityPurple: 0.1,
  opacityBlue: 0.1,
  margin: 9,
})

const IconButton: GlowConfig = Object.freeze({
  amplitude: 3,
  secondaryAmplitude: 0.16,
  primaryFreq: 12.5,
  secondaryFreq: 10,
  speed: 4,
  blur: 0,
  opacityPink: 0.1,
  opacityPurple: 0.1,
  opacityBlue: 0.1,
  margin: 7,
})

const ToolOutput: GlowConfig = Object.freeze({
  amplitude: 6,
  secondaryAmplitude: 0.25,
  primaryFreq: 97,
  secondaryFreq: 34,
  speed: 2.8,
  blur: 1.6,
  opacityPink: 0.15,
  opacityPurple: 0.16,
  opacityBlue: 0.11,
  margin: 10,
})

const glows = { Button, ChatVoice, IconButton, ToolOutput } as const
export default glows
